var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        gap: "12px",
        color: "#555",
      },
    },
    [
      _vm.extractionStep
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  gap: "8px",
                  "align-items": "center",
                },
              },
              [
                _vm.loadingSearchCriteria
                  ? _c("b-spinner", { attrs: { small: "" } })
                  : _c("span", [_vm._v("♦")]),
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.extractionStep.title)),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.extractionStepTimeLabel))]),
              ],
              1
            ),
            _vm.showTermsEditor
              ? _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _vm.gateActive && _vm.gateStepId === "1"
                      ? _c(
                          "workflow-step-gate",
                          {
                            attrs: { tight: "" },
                            on: {
                              continue: function ($event) {
                                return _vm.$emit("approve-gate")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " Search terms and research context are extracted from your query. Please review terms, edit them if necessary. When you are ready, hit the Continue button. "
                            ),
                            _c("br"),
                            _vm._v(
                              " We will use these terms to retrieve phenotype-gene set cluster and gene-set evidence data from the "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "reveal-gate-link",
                                attrs: {
                                  href: "https://cfdeknowledge.org/r/kc_gsb?source=all&model=cfde",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [_vm._v("PIGEAN")]
                            ),
                            _vm._v(" knowledge graph. "),
                          ]
                        )
                      : _vm._e(),
                    _vm.extractionAmbiguityCheck &&
                    _vm.extractionAmbiguityCheck.has_ambiguity &&
                    !_vm.extractionAmbiguityDismissed
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "alert alert-warning py-2 px-3 reveal-extraction-section-gap",
                            attrs: { role: "alert" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-start",
                              },
                              [
                                _c("div", { staticClass: "small pr-2" }, [
                                  _c("strong", [
                                    _vm._v("Interpretation note:"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.extractionAmbiguityCheck
                                          .warning_message
                                      ) +
                                      " "
                                  ),
                                  _vm.extractionAmbiguityCheck
                                    .anti_anchor_terms &&
                                  _vm.extractionAmbiguityCheck.anti_anchor_terms
                                    .length
                                    ? _c("div", { staticClass: "mt-1" }, [
                                        _c("strong", [
                                          _vm._v("Detected anti-anchor terms:"),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.extractionAmbiguityCheck.anti_anchor_terms.join(
                                                ", "
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close p-0 m-0",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Dismiss",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("dismiss-ambiguity")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.multiQueryRoutes.length ||
                    _vm.alternativeQueries.length ||
                    _vm.usePerRouteSearchTermsEditor
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "mt-3 d-flex flex-column flex-lg-row align-items-start",
                            staticStyle: { gap: "16px" },
                          },
                          [
                            _vm.multiQueryRoutes.length
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1 1 70%",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold small text-muted mb-2",
                                      },
                                      [
                                        _vm._v(
                                          "Best matching data retrieval direction"
                                        ),
                                      ]
                                    ),
                                    _vm.recommendedRoute
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-3" },
                                          [
                                            _c(
                                              "workflow-route-direction-card",
                                              {
                                                attrs: {
                                                  route: _vm.recommendedRoute,
                                                  selected: _vm.isRouteSelected(
                                                    _vm.recommendedRoute
                                                      .route_id
                                                  ),
                                                  "show-select":
                                                    !_vm.isRouteSelected(
                                                      _vm.recommendedRoute
                                                        .route_id
                                                    ),
                                                  selectable: _vm.termsEditable,
                                                  "show-terms-editor":
                                                    _vm.usePerRouteSearchTermsEditor &&
                                                    !!_vm.routeEditRow(
                                                      _vm.recommendedRoute
                                                    ),
                                                  "edit-row": _vm.routeEditRow(
                                                    _vm.recommendedRoute
                                                  ),
                                                  "terms-editable":
                                                    _vm.termsEditable,
                                                },
                                                on: {
                                                  select: function ($event) {
                                                    return _vm.$emit(
                                                      "select-route",
                                                      $event
                                                    )
                                                  },
                                                  "update-route-edit-field":
                                                    function ($event) {
                                                      return _vm.$emit(
                                                        "update-route-edit-field",
                                                        $event
                                                      )
                                                    },
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.otherRoutes.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reveal-other-directions",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "route-terms-edit-toggle btn btn-link d-inline-flex align-items-center p-0 text-decoration-none mb-2",
                                                attrs: {
                                                  type: "button",
                                                  "aria-expanded":
                                                    _vm.otherDirectionsOpen
                                                      ? "true"
                                                      : "false",
                                                  "aria-controls":
                                                    "reveal-other-directions-panel",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toggleOtherDirections.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Other directions (" +
                                                        _vm._s(
                                                          _vm.otherRoutes.length
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                ),
                                                _c("b-icon", {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    icon: _vm.otherDirectionsOpen
                                                      ? "chevron-up"
                                                      : "chevron-down",
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.otherDirectionsOpen
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column reveal-other-directions-panel",
                                                    attrs: {
                                                      id: "reveal-other-directions-panel",
                                                      role: "region",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.otherRoutes,
                                                    function (route) {
                                                      return _c(
                                                        "workflow-route-direction-card",
                                                        {
                                                          key:
                                                            "multi-route-other-" +
                                                            route.route_id,
                                                          attrs: {
                                                            route: route,
                                                            selected:
                                                              _vm.isRouteSelected(
                                                                route.route_id
                                                              ),
                                                            "show-select": "",
                                                            selectable:
                                                              _vm.termsEditable,
                                                            "show-terms-editor":
                                                              _vm.usePerRouteSearchTermsEditor &&
                                                              !!_vm.routeEditRow(
                                                                route
                                                              ),
                                                            "edit-row":
                                                              _vm.routeEditRow(
                                                                route
                                                              ),
                                                            "terms-editable":
                                                              _vm.termsEditable,
                                                          },
                                                          on: {
                                                            select: function (
                                                              $event
                                                            ) {
                                                              return _vm.$emit(
                                                                "select-route",
                                                                $event
                                                              )
                                                            },
                                                            "update-route-edit-field":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "update-route-edit-field",
                                                                  $event
                                                                )
                                                              },
                                                          },
                                                        }
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm.usePerRouteSearchTermsEditor ||
                            _vm.alternativeQueries.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "reveal-terms-side-column mb-0",
                                    staticStyle: {
                                      flex: "1 1 30%",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _vm.usePerRouteSearchTermsEditor
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reveal-shared-research-context-section mb-3",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "small font-weight-bold text-muted mb-1 d-block",
                                              },
                                              [
                                                _vm._v(
                                                  "Shared research context"
                                                ),
                                              ]
                                            ),
                                            _c("textarea", {
                                              staticClass:
                                                "form-control form-control-sm",
                                              staticStyle: {
                                                "min-height": "10em",
                                                resize: "vertical",
                                              },
                                              attrs: {
                                                rows: "4",
                                                placeholder:
                                                  "Enter research context",
                                                disabled: !_vm.termsEditable,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.sharedResearchContext,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.$emit(
                                                    "update:sharedResearchContext",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.alternativeQueries.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reveal-alt-queries-block mb-0",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-weight-bold small text-muted mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  "Suggested pro-anchor paths"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "reveal-alt-query-links mb-0",
                                              },
                                              _vm._l(
                                                _vm.alternativeQueries,
                                                function (opt, idx) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key:
                                                        "alt-below-" +
                                                        idx +
                                                        "-" +
                                                        opt,
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "reveal-alt-query-link",
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.$emit(
                                                                "select-alternative-query",
                                                                opt
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(opt))]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    !_vm.usePerRouteSearchTermsEditor
                      ? _c("b-table", {
                          staticClass: "mb-2",
                          attrs: {
                            items: _vm.searchCriteriaEditRows,
                            fields: [
                              {
                                key: "type",
                                label: "Type",
                                thStyle: { width: "34%" },
                              },
                              { key: "term", label: "Term" },
                            ],
                            small: "",
                            striped: "",
                            responsive: "sm",
                            "head-variant": "light",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(type)",
                                fn: function (row) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(row.item.type))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(term)",
                                fn: function (row) {
                                  return [
                                    row.item.type === "Research context"
                                      ? _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row.item.term,
                                              expression: "row.item.term",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          staticStyle: {
                                            "min-height": "6.5em",
                                            resize: "vertical",
                                          },
                                          attrs: {
                                            rows: "4",
                                            placeholder:
                                              "Enter research context",
                                            disabled: !_vm.termsEditable,
                                          },
                                          domProps: { value: row.item.term },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                row.item,
                                                "term",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row.item.term,
                                              expression: "row.item.term",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "Comma-separated terms",
                                            disabled: !_vm.termsEditable,
                                          },
                                          domProps: { value: row.item.term },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                row.item,
                                                "term",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3596693974
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }